/* istanbul ignore file */
import PercentageSlider from 'components/PercentageSlider';
import { StyledBenchmarksSelector } from './BenchmarkSelector.style';
import { onCategoriesBenchmarksChange } from '../../useFormState/form.state.actions';
import { orderBy } from 'lodash';
import { CATEGORIES_KEYS } from '../../../../CategoriesWidget/useCategoriesWidget/useCategoriesWidget';

const generateBenchmarkConfig = category => ({
  value: category.benchmark,
  name: category.name,
  color: category.color
});

const isPotentialSavingsOutOfRange = value => {
  const min = 3;
  const max = 20;
  return value > max || value < min;
};

const BenchmarkSelector = ({ formState }) => {
  const {
    categories,
    [CATEGORIES_KEYS.POTENTIAL_SAVINGS]: potentialSavings = {},
    dispatch
  } = formState;

  const orderedCategories = orderBy(categories, ['order'], ['asc']);
  const benchmarksConfig = orderedCategories.map(generateBenchmarkConfig);
  if (potentialSavings.enabled)
    benchmarksConfig.push(generateBenchmarkConfig(potentialSavings));

  const onChange = newConfig => {
    if (potentialSavings.enabled) {
      const potentialSavingsBenchmark = newConfig[newConfig.length - 1].value;
      if (isPotentialSavingsOutOfRange(potentialSavingsBenchmark)) return;
    }
    const values = Object.values(newConfig).map(item => item.value);
    if (values.some(value => value === 0)) return;

    dispatch(onCategoriesBenchmarksChange(newConfig));
  };

  return (
    <StyledBenchmarksSelector>
      <PercentageSlider
        config={benchmarksConfig}
        step={0.5}
        onChange={onChange}
      />
    </StyledBenchmarksSelector>
  );
};

export default BenchmarkSelector;
